
import CustomElement from '../core/custom.js';
import Emitter from '../core/emitter.js';
import Viewport from '../stores/viewport.js'
import getOffsetTop from '../utilities/getOffsetTop.js'
import remapRange from '../utilities/remapRange.js'
import clamp from '../utilities/clamp.js'
import { easeInOutQuad, easeOutSine } from'../utilities/easings.js'
  
export default window.customElements.define('block-industries', class extends CustomElement {
    constructor() {
        super();

		this._onResize = this.onResize.bind(this)
		this._onUpdate = this.onUpdate.bind(this)
    }

    connectedCallback() {
        super.connectedCallback();

		this._props.enabled = this.dataset.enabled === 'true' || false

		this.$background = this.querySelector('.js-background')

		if (!this.$background) {
            return console.warn('BlockIndustries: This component must be have a .js-background child', this)
        }

		if (!this._props.enabled) return 

		Emitter.on('resize', this._onResize)
		Emitter.on('update', this._onUpdate)

		this._onResize()
    }

    disconnectedCallback() {
        super.disconnectedCallback();

		Emitter.off('resize', this._onResize)
		Emitter.off('update', this._onUpdate)
    }

	onResize() {
		this._offsetTop = getOffsetTop(this)
	}

	onUpdate() {
		let progress = remapRange(this._offsetTop, this._offsetTop + Viewport.height, 1, 0, window.scrollY)
		progress = clamp(progress, 0, 1)
		this._scale = remapRange(1, 0, 1, 0.5, easeInOutQuad(progress))

		if (window.scrollY < this._offsetTop) {
			this._translateY = 0
			this._opacity = 1
		} else if (window.scrollY >= this._offsetTop && window.scrollY < this._offsetTop + Viewport.height) {
			let progress = remapRange(-Viewport.height, 0, 0, 1,  this._offsetTop - window.scrollY)
			progress = easeOutSine(progress)
			this._translateY =  remapRange(0, 1, -Viewport.height, 0, progress)
			this._opacity = 1
		} else {
			this._translateY = -Viewport.height
			this._opacity = 0
		}		

		this.$background.style.transform = ` scale(${this._scale})`
		this.style.opacity = this._opacity
		this.style.transform = ` matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ${-this._translateY}, 0, 1)`
	}
});
